import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { styled } from '@mui/material/styles'

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog"
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

import useStyles from './banners.styles'
import { uploadBanner, addNewBanner } from './banners.actions'

const defaultService = { name: '', type: '', images: [] }

const Input = styled('input')({
    display: 'none',
});

function AddImage({ setImages }) {
    const dispatch = useDispatch()
    const classes = useStyles()
    const ref = useRef()
    const [loader, setLoader] = useState(false)

    const handleFileUpload = (evt) => {
        const photo = evt.target.files[0];
        const formData = new FormData();

        formData.append("file", photo);
        setLoader(true)
        dispatch(uploadBanner(formData, (success, err) => {
            if (err) {
                console.log(err)
            } else {
                setLoader(false)
                setImages(success);
            }
        }))
    }

    return (
        <div className={classes.addImageContainer} onClick={() => ref.current.dispatchEvent(new MouseEvent('click'))}>
            <label htmlFor="upload-profile-image">
                <Input ref={ref} width="100%" accept="image/*" id="upload-profile-image" type="file" onChange={handleFileUpload} disabled={loader} />
                <AddPhotoAlternateIcon fontSize="large" />
            </label>
        </div>
    )
}

export default function AddServiceDialog({ open, onClose, rerender, setRerender }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [service, setService] = useState(defaultService);
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState([]);

    const handleClose = () => {
        setService(defaultService);
        setImages([]);
        onClose();
    }

    const onSave = () => {
        const callback = (success, err) => {
            if (err) {
                console.log(err);
            } else {
                setLoading(false);
                handleClose();
                setRerender(!rerender);
            }
        }
        if (!service.id) {
            dispatch(addNewBanner({ ...service, image: images && images.length ? images[0] : null }, callback))
        }
    }

    const handleEventChange = (val, type) => setService(serv => ({ ...serv, [type]: val }))

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Banner</DialogTitle>
            <DialogContent>
                <Box display="flex" justifyContent="space-evenly" alignItems="center" sx={{ height: 200 }}>
                    <Box display="flex" alignItems="space-evenly" flexDirection="column" justifyContent="center">
                        <TextField
                            variant="outlined"
                            label='Banner name'
                            value={service.name}
                            margin="dense"
                            classes={classes}
                            fullWidth
                            required
                            sx={{ width: 350 }}
                            onChange={evt => handleEventChange(evt.target.value, 'name')}
                        />
                        <TextField
                            variant="outlined"
                            label='Banner type'
                            value={service.type}
                            margin="dense"
                            classes={classes}
                            fullWidth
                            required
                            sx={{ width: 350 }}
                            onChange={evt => handleEventChange(evt.target.value, 'type')}
                        />
                    </Box>
                    <Divider orientation="vertical" variant="fullWidth" flexItem textAlign="center" />
                    <Box sx={{ padding: '0 1rem 0 0', maxWidth: 150, width: 150, height: 200 }}>
                        <AddImage setImages={setImages} images={images} />
                        {images.map((img, i) => <img key={i} src={img} alt='banner' className={classes.bannerImage} />)}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button color="error" sx={{ color: 'red' }} onClick={onClose}>Cancel</Button>
                <Button onClick={onSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
